module.exports = __webpack_public_path__ + "img/pl.f5a41299.png";